import { styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Box, Button, Form, Icon, Stack, Text, TextInput } from 'shell/components';

const GeneralInformation = ({ isLti = false, errors, form, handleChange, handleSubmit, handleClose }) => {
    const { t } = useTranslation('course');

    return (
        <GeneralInformationBox>
            <Stack spacing={4} sx={{ mt: 6 }}>
                <Stack direction={'row'} alignItems={'center'} justifyContent={'flex-start'}>
                    {!isLti && (
                        <Button startIcon={<Icon kind={'arrowLeft'} />} variant={'borderless'} onClick={handleClose}>
                            {t('common:controls.back', 'Back')}
                        </Button>
                    )}
                </Stack>
                <Stack spacing={1}>
                    <Text component={'h1'} variant={'h6'} weight={'medium'}>
                        {t('course-setup.create-course', 'Create a course')}
                    </Text>
                    <Text variant={'p1'}>{t('course-setup.description', 'Please enter the name of your course')}</Text>
                </Stack>
            </Stack>
            <Form onSubmit={() => handleSubmit()}>
                <InputStack spacing={6}>
                    <TextInput
                        error={Boolean(errors.courseName)}
                        helperText={errors.courseName}
                        label={t('course-setup.course-name-label', 'Course name')}
                        placeholder={t('course-setup.course-name-placeholder', 'Enter course name')}
                        required
                        value={form.courseName}
                        onChange={(e) => handleChange('courseName', e.target.value)}
                    />
                </InputStack>
                <Stack
                    sx={{ margin: (theme) => theme.spacing(6, 0, 2, 0) }}
                    direction={'row'}
                    justifyContent={'flex-end'}
                    spacing={4}
                >
                    <Button data-cy={'general-information-next-button'} type={'submit'}>
                        {t('course-setup.create-course-cta', 'Create Course')}
                    </Button>
                </Stack>
            </Form>
        </GeneralInformationBox>
    );
};

const GeneralInformationBox = styled(Box)(({ theme }) => {
    return {
        width: '100%',
        height: '100%',
        background: theme.palette.ensightful.shades[0],
    };
});

const InputStack = styled(Stack)(({ theme }) => {
    return {
        margin: theme.spacing(6, 0, 2, 0),
    };
});

export default GeneralInformation;
